import {
  aliasMailColor,
  importsColor,
  migrationsColor,
  mailColor,
  etliveColor,
  registerColor,
  supportColor,
} from "Icons/index";
import _ from "lodash";

function goToCustomizationSupport(postmaster) {
  let win = window.open("about:blank", "_blank");
  win.focus();
  win.location.replace(postmaster.customization_help_desk_url);
}

export default (postmaster) => {
  return _.compact([
    {
      category: "",
      links: [
        {
          path: "/",
          label: "sidebar.item.account.email",
          icon: mailColor,
        },
        {
          path: "/alias_email_accounts",
          label: "sidebar.item.alias.emails",
          icon: aliasMailColor,
        },
      ],
    },
    postmaster.is_vianova
      ? {
          category: "sidebar.category.importsMigrations",
          links: [
            { path: "/imports", label: "sidebar.item.imports", icon: importsColor },
            { path: "/migrations", label: "sidebar.item.migrations", icon: migrationsColor },
          ],
        }
      : null,
    {
      category: "sidebar.category.analysis",
      links: [
        { path: "/tracemail", label: "sidebar.item.etlive", icon: etliveColor, newFeature: false },
        { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
        postmaster.customization_help_desk_url && {
          label: "sidebar.item.support",
          icon: supportColor,
          action: () => goToCustomizationSupport(postmaster),
        },
      ],
    },
  ]);
};
